import _slicedToArray from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { compile, compileG } from "./internal/codegen";
import { vop } from "./internal/vop";

var $ = function $(dim) {
  return magSq.add(dim, compile(dim, function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        a = _ref2[0];

    return "".concat(a, "*").concat(a);
  }, "a", "a", null, "+", "return ", ";"));
};

export var magSq = vop();
magSq["default"](compileG(function (_ref3) {
  var _ref4 = _slicedToArray(_ref3, 1),
      a = _ref4[0];

  return "sum+=".concat(a, "*").concat(a, ";");
}, "a", undefined, "sum", "let sum=0;"));
export var magSq2 = $(2);
export var magSq3 = $(3);
export var magSq4 = $(4);